import { getCookie, setCookie } from "../cookies/cookies";
import { isVerifiedOfflineAvVariant } from "../offlineRegistration/offlineRegistration";

export const IS_AGE_CONFIRMED_COOKIE_NAME = "isAgeConfirmed";
export const AGE_CONFIRMED_EVENT = "ageConfirmed";

const AGE_CONFIRMED_VALUE = "true";

export const hasAgeConfirmedCookie = () => {
  try {
    return getCookie(IS_AGE_CONFIRMED_COOKIE_NAME) === AGE_CONFIRMED_VALUE;
  } catch {
    return false;
  }
};

export const setAgeConfirmedFallbackStorage = () => {
  try {
    sessionStorage.setItem(IS_AGE_CONFIRMED_COOKIE_NAME, AGE_CONFIRMED_VALUE);
  } catch {
    // ignore
  }

  try {
    localStorage.setItem(IS_AGE_CONFIRMED_COOKIE_NAME, AGE_CONFIRMED_VALUE);
  } catch {
    // ignore
  }
};

export const hasAgeConfirmedFallbackStorage = () => {
  try {
    if (sessionStorage.getItem(IS_AGE_CONFIRMED_COOKIE_NAME) === AGE_CONFIRMED_VALUE) {
      return true;
    }
  } catch {
    // ignore
  }

  try {
    if (localStorage.getItem(IS_AGE_CONFIRMED_COOKIE_NAME) === AGE_CONFIRMED_VALUE) {
      return true;
    }
  } catch {
    // ignore
  }

  return false;
};

export const isAutoConfirmAgeVerificationEnabled = () => {
  // can be extended with more conditions if needed in future
  return isVerifiedOfflineAvVariant();
};

export const isSoftAgeVerificationConfirmed = () => {
  return hasAgeConfirmedCookie() || hasAgeConfirmedFallbackStorage();
};

export const confirmSoftAgeVerification = () => {
  setCookie(IS_AGE_CONFIRMED_COOKIE_NAME, true, "/", undefined, {
    sameSite: "None",
    secure: true,
    partitioned: true,
  });

  if (!hasAgeConfirmedCookie()) {
    setAgeConfirmedFallbackStorage();
  }

  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(AGE_CONFIRMED_EVENT));
  }
};

export const initAutoConfirmAgeVerification = () => {
  if (isAutoConfirmAgeVerificationEnabled()) {
    confirmSoftAgeVerification();
  }
};
